import React, { useContext, useEffect, useState } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { Button, Dropdown } from 'components';
import './index.scss';
import { DocumentData } from '../DocumentData';
import { InfoCell } from '../InfoCell';
import { sliceStrOcr, typeOwner, typeHolder, typeOwnerHolder, typeHolderAcceptOwner, typeNone, noAssets, typePleaseAwait } from 'utils';
import { ActiveShipmentsContext, DocumentsContext, HomeContext, ModalContext } from 'contexts';
import { ACTIVE_SHIPMENT_DOCUMENT_SIGNATURE_URL, StatusTradeTrust } from 'actions';

export const DocumentSignatureDetails = () => {
    const [t] = useTranslation();
    const history = useHistory();
    const { shipmentId } = useParams();
    const {
        setVerifyWalletModal,
        setEndorsementChainModal,
    } = useContext(ModalContext);
    const { rawDocument, parties, doGetParties, documentInfo, doGetEndorsementChain } = useContext(DocumentsContext);
    const { doGetEthereumDetail } = useContext(ActiveShipmentsContext);
    const {
        walletVerify,
        callbackParties,
        idDocumentSignature,
        setCallbackParties,
        pleaseAwait,
        setOptionBlockChain,
        setStatusBlockChain,
        currentStatus,
        setCurrentStatus
    } = useContext(HomeContext);
    const [typeAssetDocument, setTypeAssetDocument] = useState([]);
    const [currentStatusNew, setCurrentStatusNew] = useState();
    const [callbackStatus, setCallbackStatus] = useState();
    const location = useLocation();
    const pathnameArr = location.pathname.split('/');
    const docId = pathnameArr[pathnameArr.length - 1];

    /*eslint-disable */
    useEffect(() => {
        if (parties?.currentHolder === walletVerify?.address?.toLowerCase() && parties?.currentOwner === walletVerify?.address?.toLowerCase()) {
            setTypeAssetDocument(typeOwnerHolder);
        } else if (parties?.currentOwner === walletVerify?.address?.toLowerCase()) {
            setTypeAssetDocument(typeOwner);
        } else if (parties?.currentHolder === walletVerify?.address?.toLowerCase() && !parties?.nominatedOwner) {
            setTypeAssetDocument(typeHolder);
        } else if (parties?.currentHolder === walletVerify?.address?.toLowerCase() && parties?.nominatedOwner) {
            setTypeAssetDocument(typeHolderAcceptOwner);
        } else {
            setTypeAssetDocument(typeNone);
        }
    }, [pleaseAwait === false, parties, walletVerify, callbackParties === true]);

    useEffect(() => {
        setCurrentStatusNew(currentStatus);
    }, [currentStatus]);

    useEffect(() => {
        setCurrentStatus('');
    }, [docId, idDocumentSignature])

    useEffect(() => {
        if (!pleaseAwait && currentStatus) {
            switch (currentStatus) {
                case StatusTradeTrust.SERRENDER_STARTED:
                    setCurrentStatusNew(StatusTradeTrust.SERRENDERED);
                    setCallbackStatus('');
                    break;
                case StatusTradeTrust.HOLDER_TRANSFER_STARTED:
                    setCurrentStatusNew(StatusTradeTrust.HOLDER_TRANSFERRED);
                    setCallbackStatus('');
                    break;
                case StatusTradeTrust.NEW_OWNER_ENDORSEMENT_STARTED:
                    setCurrentStatusNew(StatusTradeTrust.NEW_OWNER_ENDORSED);
                    setCallbackStatus('');
                    break;
                case StatusTradeTrust.OWNER_ENDORSEMENT_STARTED:
                    setCurrentStatusNew(StatusTradeTrust.OWNER_ENDORSED);
                    setCallbackStatus('');
                    break;
                case StatusTradeTrust.NEW_OWNER_NOMINATION_STARTED:
                    setCurrentStatusNew(StatusTradeTrust.NEW_OWNER_NOMINATED);
                    setCallbackStatus('');
                    break;
                default:
                    setCallbackStatus('');
                    break;
            }
        }
    }, [callbackStatus]);

    // const UpdateStatus = () => {
    //     if (!pleaseAwait && currentStatus) {
    //         switch (currentStatus) {
    //             case StatusTradeTrust.SERRENDER_STARTED:
    //                 setCurrentStatusNew(StatusTradeTrust.SERRENDERED);
    //                 setCallbackStatus(false);
    //                 break;
    //             case StatusTradeTrust.HOLDER_TRANSFER_STARTED:
    //                 setCurrentStatusNew(StatusTradeTrust.HOLDER_TRANSFERRED);
    //                 setCallbackStatus(false);
    //                 break;
    //             case StatusTradeTrust.NEW_OWNER_ENDORSEMENT_STARTED:
    //                 setCurrentStatusNew(StatusTradeTrust.NEW_OWNER_ENDORSED);
    //                 setCallbackStatus(false);
    //                 break;
    //             case StatusTradeTrust.OWNER_ENDORSEMENT_STARTED:
    //                 setCurrentStatusNew(StatusTradeTrust.OWNER_ENDORSED);
    //                 setCallbackStatus(false);
    //                 break;
    //             case StatusTradeTrust.NEW_OWNER_NOMINATION_STARTED:
    //                 setCurrentStatusNew(StatusTradeTrust.NEW_OWNER_NOMINATED);
    //                 setCallbackStatus(false);
    //                 break;
    //             default:
    //                 setCallbackStatus(false);
    //                 break;
    //         }
    //     }
    // };

    useEffect(() => {
        const handleGetEndorsementChain = () => {
            if (documentInfo && walletVerify) {
                const param = {
                    dltID: docId,
                    isDemo: false,
                    tokenRegistryAddress: documentInfo?.tokenRegistryAddress,
                    merkleRoot: documentInfo?.merkleRoot,
                    organizationId: walletVerify?.orgId,
                    walletPassword: documentInfo?.walletPassword
                };
                const header = {
                    wallet: walletVerify?.address,
                    blockchain: "Ethereum",
                    orgId: walletVerify?.orgId,
                }
                doGetEndorsementChain(param, header, (data) => {
                });
            } else {
                setVerifyWalletModal(true);
            }
        };
        handleGetEndorsementChain();
    }, [parties])

    useEffect(() => {
        const callbackData = () => {
            let number = 0;
            const payload = {
                dltID: idDocumentSignature ? idDocumentSignature : docId,
                isDemo: false,
                tokenRegistryAddress: documentInfo?.tokenRegistryAddress,
                merkleRoot: documentInfo?.merkleRoot,
                organizationId: walletVerify?.orgId,
                walletPassword: documentInfo?.walletPassword
            };
            const header = {
                wallet: walletVerify?.address,
                blockchain: "Ethereum",
                orgId: walletVerify?.orgId,
            }
            const interval = setInterval(() => {
                number = number + 1;
                if (callbackParties === true) {
                    doGetParties(payload, header, (boolen) => {
                        if (boolen) doGetEthereumDetail(idDocumentSignature ? idDocumentSignature : docId, walletVerify?.orgId, (data) => {
                          if(data.ret.tradeTrust.status !== StatusTradeTrust.ISSUED) setCurrentStatus(data.ret.tradeTrust.status);
                          setCallbackStatus(true);
                        });
                    });
                    if (number === 2 || !pleaseAwait) {
                        setCallbackParties(false);
                        setStatusBlockChain([]);
                        clearInterval(interval);
                    }
                }
            }, 30000)
        }
        callbackData();
    }, [callbackParties === true]);
    /*eslint-enable */

    const { wallets } = useContext(ActiveShipmentsContext);

    const handleGoBack = () => {
        history.push(ACTIVE_SHIPMENT_DOCUMENT_SIGNATURE_URL.replace(':shipmentId', shipmentId));
    }

    const chooseTypeGenerateDoc = (value) => {
        setOptionBlockChain(value.key);
        setVerifyWalletModal(true);
    }

    const handleDowload = (data, name) => {
        const elementData = document.createElement('a');
        const type = name.split(".").pop();
        elementData.href = URL.createObjectURL(new Blob([data], { type: `text/${type === "txt" ? "plain" : type}` }));
        elementData.download = name;
        elementData.click();
    }

    const hanldChangeWallet = () => {
        setVerifyWalletModal(true);
    }

    const hanldMoveToCorda = () => {

    }

    const handleViewTradeTrust = (href) => {
        window.open("http:" + href);
    }

    const handleViewRegistry = (href) => {
        window.open("https://rinkeby.etherscan.io/address/" + href);
    }

    const hanldViewEndosementChain = () => {
        setEndorsementChainModal(true);
    }

    const findWalletName = (address) => {
        let wallet = wallets.find(wallet => wallet?.encWallet?.address.toLowerCase() === address);
        if (wallet) {
            return `(${wallet.accountName})`;
        } else {
            return "";
        }
    }

    const convertString = (string) => {
        if (string) return string.replaceAll('-', ' ').charAt(0).toUpperCase() + string.replaceAll('-', ' ').slice(1);
        return '';
    }

    return rawDocument && (
        <div className="tr__shipment-doc">
            <div className="tr__shipment-doc--header d-flex align-items-center justify-content-between">
                <div className="flex align-items-center">
                    <p className="tr__link tag mrx2" onClick={handleGoBack}>
                        <i className="icon-chevron-left" />
                        <span>{t("home.active-shipment.details.tabs.issues-tab.back")}</span>
                    </p>
                </div>
                <div className="doc-actions d-flex align-items-center">
                    <div className={`h6 text-capitalize status ${currentStatusNew}`}>
                        <p className="f-medium">{convertString(currentStatusNew)}</p>
                    </div>
                    <Button
                        className="outline"
                        type="secondary"
                        onClick={() => handleDowload(JSON.stringify(rawDocument?.wrappedDocument), 'issued.tt')}
                    >
                        {t("Download")}
                    </Button>
                    <Button
                        className="outline"
                        type="secondary"
                        onClick={() => hanldChangeWallet()}
                    >
                        {t("Change wallet")}
                    </Button>
                    <Button
                        className="outline"
                        type="secondary"
                        onClick={() => hanldMoveToCorda()}
                        disabled
                    >
                        {t("Move to Corda")}
                    </Button>
                    <Button
                        className="outline"
                        type="secondary"
                        onClick={() => handleViewTradeTrust(sliceStrOcr(rawDocument?.wrappedDocument?.data?.links?.self?.href))}
                    >
                        {t("View at TradeTrust")}
                    </Button>
                </div>
            </div>
            <div className="col-12 tr__shipment-doc--body d-flex justify-content-between">
                <DocumentData metadata={rawDocument?.wrappedDocument?.data?.data} />
                <div className="col-4 tr__shipment-doc--column-details">
                    <div className="tr__shipment-doc--dropdown-assets">
                        <div className="view-endosementchain">
                            {pleaseAwait ? <Dropdown
                                className="select manage-assets"
                                icon="icon-chevron-down"
                                mode="select"
                                name="scac"
                                value={typePleaseAwait[0]}
                                defaultValue={typePleaseAwait[0]}
                                options={typePleaseAwait.map((l) => {
                                    return {
                                        ...l,
                                        value: l.value
                                    }
                                })}
                            /> : typeAssetDocument.length > 0 ? <Dropdown
                                className="select manage-assets"
                                icon="icon-chevron-down"
                                mode="select"
                                name="scac"
                                placeholder="Manage access"
                                options={typeAssetDocument.map((l) => {
                                    return {
                                        ...l,
                                        value: l.value
                                    }
                                })}
                                onChange={value => chooseTypeGenerateDoc(value)}
                            /> : <Dropdown
                                className="select manage-assets"
                                icon="icon-chevron-down"
                                mode="select"
                                name="scac"
                                value={noAssets[0]}
                                defaultValue={noAssets[0]}
                            />}
                            <div className="flex justify-content-between">
                                <Button className="outline" onClick={() => handleViewRegistry(sliceStrOcr(rawDocument?.wrappedDocument?.data?.issuers[0].tokenRegistry))}>View BL Registry</Button>
                                <Button className="outline" onClick={() => hanldViewEndosementChain()}>View Endorsement chain</Button>
                            </div>
                        </div>
                    </div>
                    <div className="doc--comment">
                        <div className="">
                            <h2 className="h2 f-medium">File details</h2>
                            <div className="col-12">
                                <div className='row'>
                                    <InfoCell
                                        className="col-sm-12 rowName"
                                        label={"File name"}
                                        value={rawDocument?.fileName}
                                    />
                                    <InfoCell
                                        className="col-sm-12 rowName"
                                        label={"Version"}
                                        value={rawDocument?.wrappedDocument?.version}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="">
                            <h2 className="h2 f-medium">Issuers</h2>
                            <div className="col-12">
                                <div className='row'>
                                    <InfoCell
                                        className="col-sm-12 rowName"
                                        label={"Name"}
                                        value={sliceStrOcr(rawDocument?.wrappedDocument?.data?.issuers[0]?.name)}
                                    />
                                    <InfoCell
                                        className="col-sm-6"
                                        label={"Type"}
                                        value={sliceStrOcr(rawDocument?.wrappedDocument?.data?.issuers[0]?.identityProof.type)}
                                    />
                                    <InfoCell
                                        className="col-sm-6"
                                        label={"Location"}
                                        value={sliceStrOcr(rawDocument?.wrappedDocument?.data?.issuers[0]?.identityProof.location)}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="mtx2">
                            <h2 className="h2 f-medium">Owner</h2>
                            <div className="col-12">
                                <div className='row'>
                                    <InfoCell
                                        className="col-sm-12 rowName"
                                        label={"Account address"}
                                    >
                                        <div>
                                            <div className="f-medium">{findWalletName(parties?.currentOwner)} :</div>
                                            {!parties?.currentOwner ? "-" : parties?.currentOwner}
                                        </div>
                                    </InfoCell>
                                </div>
                            </div>
                        </div>
                        <div className="">
                            <h2 className="h2 f-medium">Holder</h2>
                            <div className="col-12">
                                <div className='row'>
                                    <InfoCell
                                        className="col-sm-12 rowName"
                                        label={"Account address"}
                                    >
                                        <div>
                                            <div className="f-medium">{findWalletName(parties?.currentHolder)} :</div>
                                            {!parties?.currentHolder ? "-" : parties?.currentHolder}
                                        </div>
                                    </InfoCell>
                                </div>
                            </div>
                        </div>
                        <div className="">
                            <h2 className="h2 f-medium">Signature</h2>
                            <div className="col-12">
                                <div className='row'>
                                    <InfoCell
                                        className="col-sm-12 rowName"
                                        label={"Type"}
                                        value={rawDocument?.wrappedDocument?.signature?.type}
                                    />
                                    <InfoCell
                                        className="col-sm-12 rowName"
                                        label={"Target hash"}
                                        value={rawDocument?.wrappedDocument?.signature?.targetHash}
                                    />
                                    <InfoCell
                                        className="col-sm-12 rowName"
                                        label={"Merkie Root"}
                                        value={rawDocument?.wrappedDocument?.signature?.merkleRoot}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

DocumentSignatureDetails.propTypes = {
};
